import React from 'react'
import { connect } from 'react-redux'
import { logout } from 'ducks/app'
import { UserOutlined } from '@ant-design/icons';
import { Menu, Dropdown, Avatar, Badge } from 'antd'

const mapDispatchToProps = dispatch => ({
  logout: event => {
    event.preventDefault()
    dispatch(logout())
  }
})

const mapStateToProps = (state, props) => ({
  role: state.login.role,
  user: state.login.username,
  bankAccount: state.login.bankAccount,
})

@connect(mapStateToProps, mapDispatchToProps)
class ProfileMenu extends React.Component {
  render() {
    const { logout, user } = this.props
    const menu = (
      <Menu selectable={false}>
        <Menu.Item>
          <div className="rfq__widget__system-status__item">
            <strong>Login:</strong> {user}
          </div>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item>
          <a href="javascript: void(0);" onClick={logout}>
            <i className="topbar__dropdownMenuIcon icmn-exit" /> Logout
          </a>
        </Menu.Item>
      </Menu>
    )
    return [<div
      key="menu_1"
      className="topbar__dropdown d-inline-block"
      style={{ marginRight: '10px' }}
    >
    </div>,
    <div
      key="menu_2"
      className="topbar__dropdown d-inline-block"
    >
      <Dropdown
        overlay={menu}
        trigger={['click']}
        placement="bottomRight"
      >
        <a className="ant-dropdown-link" href="/">
          <Badge>
            <Avatar className="topbar__avatar" shape="square" size="small" icon={<UserOutlined />} />
          </Badge>
        </a>
      </Dropdown>
    </div>];
  }
}

export default ProfileMenu
